// extracted by mini-css-extract-plugin
export var navbarSubLink = "C_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "C_t3 d_f0 d_dB";
export var subPageLink = "C_gf d_gf";
export var burger = "C_vr";
export var sublinkSize = "C_vs";
export var linkSize = "C_vt";
export var Link = "C_r6 t_r6 t_rv t_rQ";